<template lang="pug">
  .index
    h1(v-html='headline')
    seperator
    .body
      p(v-for='paragraph in body', v-html='paragraph')
    .clear
</template>

<script>
  import seperator from '@/components/Seperator'
  export default {
    components: {
      seperator
    },
    data () {
      return {
        title: 'Donauhof Wien',
        indicator: require('@/assets/img/donauhof-home.svg'),
        image: require('@/assets/img/donauhof-home-image.jpg'),
        background: {
          rotate: 45,
          scale: {
            x: 4,
            y: 4
          },
          translate: {
            // x: '-30%',
            // y: '275%'
            x: '-15%',
            y: '-30%'
          }
        },
        headline: 'In den Gemäuern des um 1900 errichteten »Hotel Donauhof«, das die letzten Jahrzehnte als Holzlager diente, entsteht Neues.',
        body: [
          'Durch die Revitalisierung des Donauhofs entstehen im zweiten Wiener Gemeindebezirk auf über 1000m<sup>2</sup> ein Eventspace (im alten Ballsaal des Hotels), das Kaffeehaus Donauhof, sowie ein Coworking Space & Werkstätten.',
          'Im Donauhof sollen Nachbarschaft, soziale & innovative Projekte und Start Ups ihren Platz finden.'
        ]
      }
    },
    head () {
      return {
        title: this.title,
        titleTemplate: '%s'
      }
    }
    // created () {
    //   this.$parent.currentIndicator = this.indicator
    //   this.$parent.currentImage = this.image
    // }
  }
</script>

<style lang="scss" scoped>
  @import "~utils";
</style>



// WEBPACK FOOTER //
// Index.vue?00fa2214